import type { IconPropTypes } from '@/legacy/types';

const NotificationIcon = (props: IconPropTypes) => {
	const { width, height, className } = props;
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={width || 16}
			height={height || 16}
			viewBox='0 0 16 16'
			fill='none'
			className={className}
		>
			<path
				stroke={props.color || 'currentColor'}
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth={1.143}
				d='M6.856 14.643h2.286M12.571 6.071a4.571 4.571 0 1 0-9.143 0v4a1.714 1.714 0 0 1-1.714 1.715h12.571a1.715 1.715 0 0 1-1.714-1.715v-4Z'
			/>
		</svg>
	);
};

export default NotificationIcon;
